import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit'
import AdminApiClient from '../../../utils/http-clients/AdminApiClient'
import { IModelParams, IModelResponse, IModelState } from '../../types'

const adminApiClient = AdminApiClient.getInstance()

export const fetchCreateModel = createAsyncThunk(
  'listModels/fetchCreateModel',
  async (params: IModelParams, { rejectWithValue }) => {
    try {
      const response = await adminApiClient.createModel(params)
      return response.data
    } catch (error: any) {
      if (!error.response) {
        throw error
      }

      return rejectWithValue(error)
    }
  }
)

const initialState: IModelState = {
  isLoading: false,
  response: null,
  error: null
}

const createModelSlice = createSlice({
  name: 'states/show',
  initialState,
  reducers: {
    resetCreateModel: () => initialState
  },
  extraReducers: builder => {
    builder.addCase(fetchCreateModel.pending, state => {
      state.isLoading = true
      state.response = null
      state.error = null
    })

    builder.addCase(fetchCreateModel.fulfilled, (state, action: PayloadAction<IModelResponse>) => {
      state.isLoading = false
      state.response = action.payload
      state.error = null
    })

    builder.addCase(fetchCreateModel.rejected, (state, action) => {
      state.isLoading = false
      state.response = null
      state.error = action.payload
    })
  }
})

export default createModelSlice.reducer
export const { resetCreateModel } = createModelSlice.actions
